import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CompanyService } from 'src/app/private/services/company.service';
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';

@Component({
  selector: 'app-convert-to-account',
  templateUrl: './convert-to-account.component.html',
  styleUrls: ['./convert-to-account.component.scss']
})
export class ConvertToAccountComponent {
  @Input() leadToConvert: any;
  btnLoading = false;
  @Output() reload = new EventEmitter();

  constructor(
    private toast: ToastrService,
    private api: CompanyService,
    private localStorage: LocalStorageService,
    private api2: LeadService,
    private tracker: TrackingService
    

  ) { }
  @Output() close = new EventEmitter();

  closeModal() {
    this.close.emit();
  }

  convertToAccount() {
    this.btnLoading = true;


    const updateParams = {
      ...this.leadToConvert,
      lead_status: 'Converted',
      convert_to_account: true,
      user : this.leadToConvert.user ? this.leadToConvert.user : this.localStorage.getUser()
    };

    // Call the second API
    this.api2.updateLead(updateParams).subscribe({
      next: () => {
        this.tracker.track(
  "Convert",
  "Lead to Account",
  `Lead converted to account with lead ID: ${this.leadToConvert?.lead_id} by user: ${`${this.localStorage.getUser()?.fname || ''} ${this.localStorage.getUser()?.lname || ''}`.trim() || 'Unknown'}`
);

        this.reload.emit();

        setTimeout(() => {
          this.toast.success(`Lead ID: ${this.leadToConvert?.lead_id}  Converted successfully`);
          this.closeModal();
        }, 1000);

      },
      error: (err) => {
        console.error('Update Lead Error:', err);
        this.toast.error('Failed to convert lead');
        this.btnLoading = false;
      },
      complete: () => {
        this.btnLoading = false;
      }
    });

}


}
